import React from 'react';
import {Divider} from 'semantic-ui-react';
import * as Types from './types';
import * as Op from './cg/ops';

import * as Panel2 from './panel';
import {PanelComp2} from './PanelComp';
import * as CGReact from './cg/cgreact';

type PanelSplitCompareProps = Panel2.PanelConverterProps;

const PanelSplitCompareArray: React.FC<PanelSplitCompareProps> = props => {
  const values = CGReact.useEach(props.input.path);
  if (values.loading) {
    return <div></div>;
  }
  return (
    <div
      style={{
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'row',
        width: '100%',
        height: '100%',
      }}>
      {values.result.map((node, ndx) => {
        if (!!node) {
          return (
            <div
              key={ndx}
              style={{
                display: 'flex',
                flexDirection: 'column',
                flexBasis: '100%',
                flex: 1,
                paddingRight: 32,
                overflowX: 'auto',
                overflowY: 'visible',
              }}>
              <Divider />
              <PanelComp2
                inputType={node.type}
                input={{path: node}}
                loading={props.loading}
                panelSpec={props.child}
                configMode={false}
                config={props.config}
                context={props.context}
                updateConfig={props.updateConfig}
                updateContext={props.updateContext}
              />
            </div>
          );
        } else {
          return <></>;
        }
      })}
    </div>
  );
};

const PanelSplitCompareDict: React.FC<PanelSplitCompareProps> = props => {
  const valNode = Op.opDictToArray({dict: props.input.path});
  const values = CGReact.useEach(valNode);
  if (values.loading) {
    return <div></div>;
  }
  return (
    <PanelSplitCompareArray
      {...props}
      inputType={valNode.type}
      input={{path: Op.opArray(values.result as any)}}
    />
  );
};

const PanelSplitCompare: React.FC<PanelSplitCompareProps> = props => {
  // TODO
  if ((props.inputType as Types.ArrayType).type === 'array') {
    return <PanelSplitCompareArray {...props} />;
  } else if ((props.inputType as Types.Dict).type === 'dict') {
    return <PanelSplitCompareDict {...props} />;
  } else {
    return <></>;
  }
};

export const Spec: Panel2.PanelConvertSpec = {
  id: 'split-panel',
  Component: PanelSplitCompare,
  convert: (inputType: Types.Type) => {
    if (Types.isSimpleType(inputType)) {
      return null;
    }
    if (inputType.type !== 'dict' && inputType.type !== 'array') {
      return null;
    }
    return inputType.objectType;
  },
};
